import React from 'react';
import { connect } from 'react-redux';

import { toggleSpinner } from 'apps/auth/actions/appAction';
import { setExtra } from 'apps/auth/actions/extraAction';
import { setNewFields } from 'apps/auth/actions/formAction';
import { CountryItemPanel } from 'apps/auth/components/common/components/CountryItemPanel/CountryItemPanel';
import { AMOUNT_TO_CCY } from 'apps/auth/constants/fieldsName';
import { GA_EXCHANGE_FORM_NAME } from 'apps/auth/constants/formName';
import { changeBrowserUrlWithOutReload } from 'apps/auth/helpers/api';
import update from 'apps/auth/helpers/Immutability';
import { ApiService } from 'apps/auth/services/apiService';

const CountryPanelForExchange = (props) => {
    const account = props.account;
    const nowUse = props.isFrom ? props.pocketId === account?.id : props.currentCcy == account?.pocketCurrency?.ncode;
    const code = account.pocketCurrency.code;

    const onClickHandler = (e) => {
        e.preventDefault();
        if (!nowUse) {
            props.toggleSpinner(true);
            if (!props.isFrom) {
                props.fields[AMOUNT_TO_CCY] = update(props.fields[AMOUNT_TO_CCY], { value: { $set: account.pocketCurrency.ncode } });
            }
            const url = `/auth/ga/pocket/${props.isFrom ? props.account.id : props.pocketId}/exchange?keepAmount=true&isFrom=${!props.isFrom}`;
            ApiService.fetch(
                url,
                props,
                (json) => {
                    changeBrowserUrlWithOutReload(url, json);
                    if (json) {
                        const extra = json?.extra;
                        if (json?.extra) {
                            props.setExtra(extra);
                        }
                        const fields = json?.forms?.gaExchange?.fields;
                        if (fields) {
                            props.setNewFields(props.formName, fields);
                        }
                    }
                },
                null,
                props.popupRef,
            );
        }
    };

    return (
        <CountryItemPanel
            to={`/auth/ga/pocket/${props.account.id}/exchange`}
            onClick={onClickHandler}
            flagIconName={code.toLowerCase()}
            countryName={code.toUpperCase()}
            isSelectedCountry={nowUse}
            countryCurrency={account.balance + ' ' + code.toLowerCase()}
            getCurrencyIcon={props.getCurrencyIcon}
            onError={props.onError}
        />
    );
};
const mapStateToProps = (state) => {
    return {
        fields: state.form[GA_EXCHANGE_FORM_NAME].fields,
        pocketId: state.extra.pocket?.id,
        formName: GA_EXCHANGE_FORM_NAME,
    };
};
export default connect(mapStateToProps, {
    toggleSpinner,
    setExtra,
    setNewFields,
})(CountryPanelForExchange);
